module.exports = __webpack_public_path__ + "images/bg_button_a.gif";